import About from '../components/About.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(About)
